const addPartnerManagerResources = {
    titleAddPartnerManager: 'Add New Partner Manager'
};
export default addPartnerManagerResources;
